export const blockExplorers: Record<string, string | null> = {
  "0x1": "https://etherscan.io/",
  "0x3": "https://ropsten.etherscan.io/",
  "0x4": "https://rinkeby.etherscan.io/",
  "0x2a": "https://kovan.etherscan.io/",
  "0x5": "https://goerli.etherscan.io/",
  "0x539": null,
  "0xa86a": "https://cchain.explorer.avax.network/",
  "0x38": "https://bscscan.com/",
  "0x61": "https://testnet.bscscan.com",
  "0x89": "https://explorer-mainnet.maticvigil.com",
  "0x13881": "https://mumbai.polygonscan.com",
  "0xfa": "https://ftmscan.com/",
};
